import React from 'react';
import { Link } from 'react-router-dom';
import { Eye, Heart, MessageCircle, Clock } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';

const BlogCardLarge = ({ blog }) => {
  return (
    <Link
      to={`/blogs/${blog.slug || blog._id}`}
      className="group block h-full cursor-pointer"
    >
      <div className="card h-full flex flex-col overflow-hidden">
        {/* Thumbnail */}
        <div className="relative w-full h-64 md:h-80 overflow-hidden bg-gray-200 dark:bg-gray-700">
          <img
            src={blog.thumbnail}
            alt={blog.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            onError={(e) => {
              e.target.src = 'https://via.placeholder.com/800x400?text=Blog+Image';
            }}
          />
          {blog.featured && (
            <span className="absolute top-4 left-4 bg-accent text-white px-3 py-1 rounded text-sm font-medium">
              Featured
            </span>
          )}
          {blog.sponsored && (
            <span className="absolute top-4 right-4 bg-yellow-500 text-white px-3 py-1 rounded text-sm font-medium">
              Sponsored
            </span>
          )}
        </div>

        {/* Content */}
        <div className="p-6 flex-1 flex flex-col">
          <span className="text-sm font-medium text-accent mb-3">
            {blog.category}
          </span>
          <h3 className="text-2xl md:text-3xl font-heading font-bold text-heading dark:text-white mb-3 line-clamp-2 group-hover:text-accent transition-colors">
            {blog.title}
          </h3>
          {blog.excerpt && (
            <p className="text-base text-gray-600 dark:text-gray-400 mb-4 line-clamp-3">
              {blog.excerpt}
            </p>
          )}
          <div className="mt-auto">
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center space-x-2">
                {blog.author?.profile?.avatar ? (
                  <img
                    src={blog.author.profile.avatar}
                    alt={blog.author.username}
                    className="w-8 h-8 rounded-full"
                  />
                ) : (
                  <div className="w-8 h-8 bg-accent rounded-full flex items-center justify-center text-white text-sm font-medium">
                    {blog.author?.username?.charAt(0).toUpperCase() || 'A'}
                  </div>
                )}
                <span className="text-sm text-gray-600 dark:text-gray-400">
                  {blog.author?.username || 'Anonymous'}
                </span>
              </div>
              <span className="text-xs text-gray-500 dark:text-gray-500 flex items-center">
                <Clock className="w-3 h-3 mr-1" />
                {blog.publishedAt
                  ? formatDistanceToNow(new Date(blog.publishedAt), { addSuffix: true })
                  : formatDistanceToNow(new Date(blog.createdAt), { addSuffix: true })}
              </span>
            </div>
            <div className="flex items-center space-x-4 text-sm text-gray-500 dark:text-gray-500">
              <div className="flex items-center">
                <Eye className="w-4 h-4 mr-1" />
                {blog.views || 0}
              </div>
              <div className="flex items-center">
                <Heart className="w-4 h-4 mr-1" />
                {blog.likes || 0}
              </div>
              <div className="flex items-center">
                <MessageCircle className="w-4 h-4 mr-1" />
                {blog.comments?.length || 0}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BlogCardLarge;
